import Utils from './Utils';
import ConfigService from "./api/Config";

/**
 * Created by faresu on 1/6/17.
 */

const validateEqual = (value1, value2) => {
  return value1 != null && value2 != null && Utils.equals(value1, value2);
};

const validateGreater = (value1, value2) => {
  return value1 != null && value2 != null && value2 > value1;
};

const validateLower = (value1, value2) => {
  return value1 != null && value2 != null && value2 < value1;
};

const validateGreaterThan = (value1, value2) => {
  return value1 != null && value2 != null && value2 >= value1;
};

const validateLowerThan = (value1, value2) => {
  return value1 != null && value2 != null && value2 <= value1;
};

const validateContains = (value1, value2, component) => {
  if (['textInput', 'textArea'].includes(component)) {
    return !Utils.isNull(value1) && !Utils.isNull(value2) ? value2.includes(value1) : false;
  }
  if (!Array.isArray(value1)) {
    value1 = value1.split(',');
  }
  if (!Array.isArray(value2)) {
    value2 = value2.split(',');
  }
  return !Utils.isEmpty(value1) && !Utils.isEmpty(value2) && validateArrayContainsArray(value1, value2)
};

const validateArrayContainsArray = (arr1, arr2) => {
  // True if arr2 contains all elements of arr1.
  return arr1.some( ai => arr2.some(ar2 => ar2.includes(ai)));
};

const validateEmpty = (value1) => {
  return Utils.isNull(value1);
};

const validateNotEmpty = (value1) => {
  return !Utils.isNull(value1);
};

export const checkConditions = (type, valueToCompare, value, component) => {
  let validates = true;
  switch (type) {
    case 'Equals':
    case 'e':
      validates = validateEqual(valueToCompare, value);
      break;
    case 'Major':
    case 'gt':
      validates = validateGreater(valueToCompare, value);
      break;
    case 'Minor':
    case 'lt':
      validates = validateLower(valueToCompare, value);
      break;
    case 'Major and Equals':
    case 'let':
      validates = validateGreaterThan(valueToCompare, value);
      break;
    case 'Minor and Equals':
    case 'get':
      validates = validateLowerThan(valueToCompare, value);
      break;
    case 'Contains':
    case 'c':
      validates = validateContains(valueToCompare, value, component);
      break;
    case 'Empty':
    case 'em':
    case 'Is Empty':
      validates = validateEmpty(value);
      break;
    case 'No Empty':
    case 'Not Empty':
    case 'nem':
    case 'Is Not Empty':
      validates = validateNotEmpty(value);
      break;
    default:
      validates = validateEqual(valueToCompare, value);
      break;
  }

  return validates;
};

export const getConditionValue = (conditionValue) => {
  if (Utils.isNull(conditionValue)) return null;
  var value = Array.isArray(conditionValue) ? [] : null;
  if (Array.isArray(conditionValue)) {
    conditionValue.forEach((val) => {
      value.push(val.value ? val.value : val);
    });
  }
  else {
    value = !Utils.isNull(conditionValue.value) ? conditionValue.value : conditionValue;
  }
  return value;
};

export const validateConditionals = (currentField, sections, data) => {
  let validates = true
  let arrValidates = []
  let valueCurrency = null

  if (currentField.conditions && currentField.conditions.length > 0) {
    validates = Object.keys(data.data).length > 0
    if (validates) {
      currentField.conditions.map(condition => {
        if (validates) {
          sections.map(section => {
            if (validates) {
              section.children.map(field => {
                if (validates) {
                  const conditionField = (condition.conditionField && condition.conditionField.value) ? condition.conditionField.value : condition.conditionField;
                  if (field.id === conditionField && data.data[field.id]) {
                    const conditionType = (condition.conditionType && condition.conditionType.value) ? condition.conditionType.value : condition.conditionType;
                    if (field.component.includes('checkbox') || field.component === 'select' || field.component.includes('radio')) {
                      if (field.component.includes('checkbox')) {
                        let value = data.data[field.id] && Array.isArray(data.data[field.id].value) ? data.data[field.id].value.filter((item) => {
                          return checkConditions(conditionType, getConditionValue(condition.conditionValue), field.options[item].value, field.component)
                        }) : []
                        validates = value.length > 0
                        arrValidates.push(value.length > 0)
                      } else {
                        validates = checkConditions(conditionType, getConditionValue(condition.conditionValue), (data.data[field.id] && field.options[data.data[field.id].value] && field.options[data.data[field.id].value].value) ? field.options[data.data[field.id].value].value : null, field.component)
                        arrValidates.push(validates)
                      }
                    } else {
                      if (field.component === 'currencyInput') {
                        if (data.data[field.id] && data.data[field.id].value && typeof data.data[field.id].value === 'string' && data.data[field.id].value.includes('$')) {
                          let valueWithout = data.data[field.id].value.substring(1, data.data[field.id].value.length)
                          valueCurrency = parseFloat(valueWithout)
                        }
                      }
                      validates = checkConditions(conditionType, getConditionValue(condition.conditionValue), valueCurrency || data.data[field.id].value, field.component)
                      arrValidates.push(validates)
                    }
                  }
                } else {
                  validates = false
                  arrValidates.push(validates)
                }
              })
            } else {
              validates = false
              arrValidates.push(validates)
            }
          })
        } else {
          validates = false
          arrValidates.push(validates)
        }
      })
    } else {
      validates = false
      arrValidates.push(validates)
    }
  }
  if (currentField.conditions) {
    return validates && currentField.conditions && arrValidates.length === currentField.conditions.length
  }
  return validates && currentField.conditions && arrValidates.length === currentField.conditions.length || arrValidates.length === 0
}

export const checkTriggerCondition = (condition, fieldConfiguration, value) => {
  const conditionValue = getConditionValue(condition.conditionValue);
  const conditionType = (condition.conditionType && condition.conditionType.value)
    ? condition.conditionType.value
    : condition.conditionType;
  let val = null;
  let date1 = null;
  let date2 = null;
  let parseConditionValue = null;
  const { component } = fieldConfiguration;
  switch (component) {
    case 'checkbox':
    case 'checkboxJustifiedLeft':
      // checkbox
      if (Array.isArray(value)) {
        val = value;
      }
      else {
        val = (!Utils.isNull(value) ? value.split(',') : []);
      }
      parseConditionValue = Array.isArray(conditionValue)
        ? conditionValue
        : [conditionValue];
      val.sort();
      parseConditionValue.sort();
      return checkConditions(conditionType, parseConditionValue.join(','), val.join(','), component);
    case 'select':
    case 'radio':
    case 'radioJustifiedLeft':
    case 'ratingScale3pt':
      // select and radio
      val = !Utils.isNull(value) ? value.toString() : value;
      return checkConditions(conditionType, conditionValue, val, component);
    case 'currencyInput':
      // currency
      parseConditionValue = parseFloat(conditionValue);
      if (typeof value === 'string' && value.includes('$')) {
        return checkConditions(conditionType, parseConditionValue,
          parseFloat(value.substring(1, value.length)), component);
      }
      else {
        return checkConditions(conditionType, parseConditionValue, parseFloat(value), component);
      }
    case 'numberInput':
    case 'sliderRange':
    case 'starRate':
      // number and sliderRange and starRate
      return checkConditions(conditionType, parseFloat(conditionValue), parseFloat(value), component);
    case 'dateTimeInput':
      // dateTime
      date1 = Utils.formatDateTime(new Date(conditionValue));
      date2 = Utils.formatDateTime(new Date(value));
      return checkConditions(conditionType, date1, date2, component);
    case 'dateInput':
      // date
      date1 = Utils.formatDate(new Date(conditionValue));
      date2 = Utils.formatDate(new Date(value));
      return checkConditions(conditionType, date1, date2, component);
    case 'timeInput':
      // time
      date1 = Utils.formatTime(new Date(conditionValue));
      date2 = Utils.formatTime(new Date(value));
      return checkConditions(conditionType, date1, date2, component);
    default:
      // other
      return checkConditions(conditionType, conditionValue, value, component);
  }
};

export const getValueLabel = (value) => {
  if (Utils.isNull(value)) return value;
  let result = null;
  if (Array.isArray(value)) {
    let arrayValues = [];
    value.forEach((item) => {
      if (item.label) {
        arrayValues.push(item.label);
      }
      else {
        arrayValues.push(item.value ? item.value : item);
      }
    });
    result = arrayValues.join(',');
  }
  else {
    if (value.label) {
      result = value.label;
    }
    else {
      result = (value.value ? value.value : value);
    }
  }
  return result;
};

export const getConditionLabel = function (field, triggerId) {
  let triggersData = {};
  if (field && field.triggers) {
    field.triggers.map(item => {
      triggersData[item.id] = item;
    });
  }
  if (!triggersData[triggerId]) {
    return '';
  }
  else {
    let label = '- ' + triggersData[triggerId].conditionType.label + ':';
    const valueLabel = getValueLabel(triggersData[triggerId].conditionValue);
    const required = triggersData[triggerId].workOrderRequired ?
      ` <span class='InputWrapper-Label-Required' style='color: ${ ConfigService.getColor('errorColor') }'>*</span>` : '';
    return label + ' <span class="Bold"> ' + valueLabel + '</span>' + required;
  }
}
